import React, { FC } from 'react'

import * as Styled from './styled'

export interface HowToSellCardProps {
  title: string
  description: string
  link: string
  text: string
  iconType: 'promote' | 'educate' | 'escript'
}

export const HowToSellCard: FC<HowToSellCardProps> = ({
  title,
  description,
  link,
  iconType,
  text,
}) => (
  <Styled.Card>
    <Styled.Header>
      {iconType === 'promote' ? (
        <Styled.PromoteDispensaryIcon />
      ) : iconType === 'educate' ? (
        <Styled.PersonIcon />
      ) : iconType === 'escript' ? (
        <Styled.EscriptIcon />
      ) : null}
      <Styled.Title>{title}</Styled.Title>
    </Styled.Header>
    <Styled.Description>{description}</Styled.Description>
    <Styled.Footer>
      <Styled.LinkButton to={link}>
        {iconType === 'promote' ? (
          <Styled.PromoteDispensaryButtonIcon />
        ) : iconType === 'educate' ? (
          <Styled.PersonButtonIcon />
        ) : iconType === 'escript' ? (
          <Styled.EscriptButtonIcon />
        ) : null}
        {text}
      </Styled.LinkButton>
    </Styled.Footer>
  </Styled.Card>
)
